import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { PayoutMethodListResponse } from '~client/model/payout-method-list-response';
import { PayoutMethodResponse } from '~client/model/payout-method-response';
import { PaypalPayoutRequest } from '~client/model/paypal-payout-request';

/* User APIs pertaining to payouts */
export class PayoutController extends BaseController {
  /* Gets the payout methods for the user */
  public getPayoutMethods$(): Observable<PayoutMethodListResponse> {
    return this.get$('/payout/methods');
  }

  /* Creates or updates the existing payout means of a user with the single use token provided */
  public createPayoutMethod$(request: PaypalPayoutRequest): Observable<PayoutMethodResponse> {
    return this.post$('/payout/paypal', request);
  }

  /* Creates or updates the existing payment means of a user with the single use token provided */
  public archivePayoutMethod$(payoutMethodId: number): Observable<PayoutMethodResponse> {
    return this.put$(`/payout/archive?payoutMethodId=${payoutMethodId}`);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/payout-controller.ts